module.exports = __webpack_public_path__ + "static/media/twitter.923455be.svg";